<script>
  import { replaceIframes } from "../../Helper";
  import clsx from "clsx";

  export let item;
</script>

<figure class="bg-theme-minor-200">
  <img class="pointer-events-none w-full max-w-none" data-splide-lazy={item.imageSrc} alt={item.imageAlt || ""} />
  {#if item.text || item.copyright}
    <figcaption class={clsx("wisch relative p-6", item.copyright ? "pt-2" : "pt-8", item.text || "pb-2")}>
      {#if item.copyright}
        <small class="block text-right">{item.copyright.includes("©") ? "" : "© "}{item.copyright}</small>
      {/if}
      {#if item.text}
        {@html replaceIframes(item.text)}
      {/if}
    </figcaption>
  {/if}
</figure>

<style global>
  figcaption.wisch * {
    max-width: 100%;
  }
</style>
